<template>
  <b-card no-body>
    <div v-if="profile != null" class="col-md-12 pl20">
      <b-tabs
        defaultActiveKey="profile"
        content-class="mt-3"
        @activate-tab="handleActivateTab"
        pills
        card
        vertical
      >
        <b-tab
          v-for="(aSection, index) in sectionsValid"
          :key="index"
          :title="aSection.title"
        >
          <div v-if="false" :id="aSection.id" style="width: 10px">
            *
          </div>
          <component
            :is="aSection.component"
            v-bind="Object.assign({}, propsData)"
            :ref="aSection.componentName"
          >
          </component>
        </b-tab>
      </b-tabs>
    </div>
  </b-card>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import Vue from "vue";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import TheMask from "vue-the-mask/src/component";
import Calendar from "./profileCalendar/index";
import VueTour from "vue-tour";
//Info
import PersonalInfo from "./personalnfo";
import EmergencyContacts from "./emergencyContacts";
import PrimaryCarePhysician from "./personalnfo";
import MedicalHistory from "./personalnfo";
import HealthInsuranceInfo from "./personalnfo";
import PharmacyInfo from "./personalnfo";
import TestsAndLabResults from "./personalnfo";
import FamilyMedicalHistory from "./personalnfo";
import SurgicalHistory from "./personalnfo";
import LifestyleInfo from "./personalnfo";
import AdvanceDirectives from "./personalnfo";
import SpecialistContactInfo from "./personalnfo";
import Hospitalizations from "./personalnfo";
import PharmacistContactInfo from "./personalnfo";
import PreferredCommunicationMethod from "./personalnfo";
import DocAndNotes from "./personalnfo";
import MedicationAndAllergies from "./personalnfo";
import AllergiesAndReactions from "./personalnfo";

Vue.use(VueTour);
require("vue-tour/dist/vue-tour.css");

export default {
  name: "Me_ProfileInfo",
  components: {
    Calendar,
    VueBootstrapTypeahead,
    TheMask,
    PersonalInfo,
    EmergencyContacts,
    PrimaryCarePhysician
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.setTypeAheads();
    this.$store.dispatch("user/getProfile");
    // this.$tours['myTour'].start()
  },
  computed: {
    ...mapGetters({}),
    sectionsValid() {
      return this.sections.filter(x => {
        return x.avail === true;
      });
    },
    propsData() {
      return {
        profile: this.profile
      };
    },
    sections() {
      return [
        {
          title: "Personal Info",
          id: "v-info-step",
          component: PersonalInfo,
          componentName: "PersonalInfo",
          avail: true
        },
        {
          title: "Emergency Contacts",
          id: "v-contacts-step",
          component: EmergencyContacts,
          componentName: "EmergencyContacts",
          avail: true
        },
        {
          title: "Primary Care Physician",
          id: "v-pcp-step",
          component: PrimaryCarePhysician,
          componentName: "PrimaryCarePhysician",
          avail: true
        },
        {
          title: "Medical History",
          id: "v-pcp-step",
          component: MedicalHistory,
          componentName: "MedicalHistory",
          avail: true
        },
        {
          title: "Health Insurance Info",
          id: "v-pcp-step",
          component: HealthInsuranceInfo,
          componentName: "HealthInsuranceInfo",
          avail: true
        },
        {
          title: "Pharmacy Info",
          id: "v-pcp-step",
          component: PharmacyInfo,
          componentName: "PharmacyInfo",
          avail: true
        },
        {
          title: "Tests & Lab Results",
          id: "v-pcp-step",
          component: TestsAndLabResults,
          componentName: "TestsAndLabResults",
          avail: true
        },
        {
          title: "Family Medical History",
          id: "v-pcp-step",
          component: FamilyMedicalHistory,
          componentName: "FamilyMedicalHistory",
          avail: true
        },
        {
          title: "Surgical History",
          id: "v-pcp-step",
          component: SurgicalHistory,
          componentName: "SurgicalHistory",
          avail: true
        },
        {
          title: "Lifestyle Info",
          id: "v-pcp-step",
          component: LifestyleInfo,
          componentName: "LifestyleInfo",
          avail: true
        },
        {
          title: "Advance Directives",
          id: "v-pcp-step",
          component: AdvanceDirectives,
          componentName: "AdvanceDirectives",
          avail: true
        }
      ];
    }
  },
  validations: {
    fullName: { required },
    birthdate: { required },
    email: { required, email }
  },
  methods: {
    handleActivateTab(tabIdx) {
      let refName = this.sectionsValid[tabIdx].componentName;

      let theComponents = this.$refs[refName];
      if (theComponents[0].hasOwnProperty("handleActivation")) {
        theComponents[0].handleActivation();
      }
    },
    addPlace(e) {
      this.places.unshift(this.place);
      this.place = "";
    },
    delPlace(place) {
      let index = this.places.indexOf(place);
      if (index > -1) {
        this.places.splice(index, 1);
      }
    },
    onContext(ctx) {
      this.context = ctx;
      let date = ctx.activeFormatted
        .split(",")
        .splice(1, 3)
        .toString()
        .trim();
      // date = date.splice(1, 3).toString().trim();
      this.birthdate = date;
    },
    validationStatus(validation) {
      return typeof validation != "undefined" ? validation.$error : false;
    },
    handleToggle(toggleInput) {
      this.shallCaptureLoc = !this.shallCaptureLoc;
      document.querySelector(".toggler").classList.toggle("bg");
      document.querySelector(".slider").classList.toggle("btns");
    },
    getLocation() {
      console.log("hi");
      {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(this.showPosition);
        } else {
          console.log("Geolocation is not supported by this browser.");
        }
      }
    },
    showPosition(position) {
      this.place = position.coords.latitude + "," + position.coords.longitude;
    },
    showCalender() {
      this.calendarShow = !this.calendarShow;
    },
    handleUpdateProfileData(type) {
      this.$v.$touch();

      if (this.$v.$pending || this.$v.$error) {
        //TODO- Fix later to properly validate- was causing a saving issue earlier with birthdat
        //show error
        //return;
      }

      let name = this.fullName.split(" ");
      let firstname = name[0];
      let lastname =
        name.length > 1
          ? this.fullName.substr(this.fullName.indexOf(" ") + 1)
          : "";

      let dataToUpdate = {
        firstname: firstname,
        lastname: lastname,
        birthdate: this.birthdate,
        phoneNumber: this.phoneNumber,
        mainline: this.mainline,
        shallCaptureLoc: this.shallCaptureLoc ? this.shallCaptureLoc : false,
        abouts: {
          language: this.language,
          timezone: this.timezone,
          spiritual: this.spiritual,
          political: this.political,
          places: this.places
        },
        force: true
      };

      this.$store.dispatch("user/updateProfile", dataToUpdate).then(res => {
        if (res) {
          this.$store.dispatch("user/getProfile").then(() => {
            this.$store.dispatch("user/showNotification", {
              title: "Changes Saved Successfully",
              description: "Your changes has been saved successfully",
              variant: "success"
            });
          });
        } else {
          this.$store.dispatch("user/showNotification", {
            title: "Ooops! could not save your profile.",
            description: "Your changes were not saved",
            variant: "error"
          });
        }
      });
    },
    setTypeAheads() {
      setTimeout(() => {
        if (
          this.profile &&
          this.profile.abouts &&
          this.profile.abouts.language &&
          this.$refs.language
        ) {
          let languages = this.$typeAheadAboutsLanguage.filter(item => {
            return this.profile.abouts.language == item.value;
          });

          this.$refs.language.$data.inputValue =
            languages.length > 0
              ? languages[0].text
              : this.profile.abouts.language;
        }

        if (
          this.profile &&
          this.profile.abouts &&
          this.profile.abouts.timezone &&
          this.$refs.timezone
        ) {
          let timezones = this.$typeAheadAboutsTimezone.filter(item => {
            return this.profile.abouts.timezone == item.value;
          });
          this.$refs.timezone.$data.inputValue =
            timezones.length > 0
              ? timezones[0].text
              : this.profile.abouts.timezone;
        }

        if (
          this.profile &&
          this.profile.abouts &&
          this.profile.abouts.spiritual &&
          this.$refs.spiritual
        )
          this.$refs.spiritual.$data.inputValue = this.profile.abouts.spiritual;
        if (
          this.profile &&
          this.profile.abouts &&
          this.profile.abouts.political &&
          this.$refs.political
        )
          this.$refs.political.$data.inputValue = this.profile.abouts.political;
      }, 100);
    }
  },
  data() {
    return {
      calendar: false,
      fullName: this.profile
        ? this.profile.firstname + " " + this.profile.lastname
        : null,
      email: this.profile ? this.profile.email : null,
      birthdate:
        this.profile && this.profile.birthdate ? this.profile.birthdate : null,
      phoneNumber:
        this.profile && this.profile.phoneNumber
          ? this.profile.phoneNumber
          : null,
      mainline:
        this.profile && this.profile.mainline ? this.profile.mainline : null,
      language:
        this.profile && this.profile.abouts && this.profile.abouts.language
          ? this.profile.abouts.language
          : null,
      //@ToDo fix the CSS of this. It is currently a hack
      shallCaptureLoc:
        this.profile && this.profile.shallCaptureLoc !== undefined
          ? this.profile.shallCaptureLoc
          : false,
      timezone:
        this.profile && this.profile.abouts && this.profile.abouts.timezone
          ? this.profile.abouts.timezone
          : null,
      spiritual:
        this.profile && this.profile.abouts && this.profile.abouts.spiritual
          ? this.profile.abouts.spiritual
          : null,
      political:
        this.profile && this.profile.abouts && this.profile.abouts.political
          ? this.profile.abouts.political
          : null,
      location: "",
      calendarShow: false,
      value: "",
      context: null,
      place: "",
      places:
        this.profile && this.profile.abouts && this.profile.abouts.places
          ? this.profile.abouts.places
          : [],
      steps: [
        {
          target: "#v-step-0", // We're using document.querySelector() under the hood
          content: `Discover <strong>Vue Tour</strong>!`
        },
        {
          target: ".v-step-1",
          content: "An awesome plugin made with Vue.js!"
        },
        {
          target: '[data-v-step="2"]',
          content:
            "Try it, you'll love it!<br>You can put HTML in the steps and completely customize the DOM to suit your needs.",
          params: {
            placement: "top"
          }
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  // background:#000 ;
}
.invalid-feedback {
  font-size: 14px;
  margin-left: 10px;
  font-family: "Nunito";
}
.form {
  margin-top: 32px;
  font-family: "Nunito", sans-serif;
  .w50 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 24px;
    margin-bottom: 16px;
    position: relative;
    @media (max-width: 650px) {
      grid-template-columns: 1fr;
      row-gap: 24px;
    }

    #icon {
      position: relative;
      span {
        position: absolute;
        position: absolute;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 5%;
      }
    }
    .select-custom {
      user-select: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      background: transparent;
      background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
      background-repeat: no-repeat;
      background-position-x: 98%;
      background-position-y: 50%;
      position: relative;
      cursor: pointer;
      .custom_dropdown {
        list-style: none;
        font-family: "Nunito", sans-serif;
        font-weight: 600;
        font-style: normal;
        position: absolute;
        background-color: #fff;
        z-index: 99;
        // margin-top: -13px;
        width: 100%;
        left: 0;
        border-radius: 0 0 12px 12px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-direction: column;
        height: 80px;
        // transform: translateY(10px);
        transition: 0.4s linear;
        cursor: pointer !important;
        padding: 0px 16px;

        box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.08);
        li {
          width: 100%;
          height: 100%;
          display: flex;
          // justify-content: center;

          align-items: center;
          border-radius: 8px;
          transition: 0.4s linear;
          &:hover span {
            color: var(--theme-color);
          }

          span {
            color: #474d52;
            text-decoration: none;
            transition: 0.4s linear;
            pointer-events: none;
            &:hover {
              color: #fff;
            }
          }
        }
      }
      .myButton {
        border: none;
        outline: none;
        background: none;
        height: 100%;
        display: flex;
        align-items: center;
      }
      // padding-top: 0;
    }
  }
  .political {
    @media (max-width: 650px) {
      margin-bottom: 24px !important;
    }
  }

  #location {
    position: relative;
    .preappend-icon,
    .append-icon {
      position: absolute;
      top: 48%;
    }
    .preappend-icon {
      left: 3%;
    }
    .append-icon {
      right: 5%;
    }
    .custom-input {
      padding-left: 50px;
    }
  }
  .custom-label {
    font-weight: 600;
    font-size: 14px;
    color: #a1b1ba;
    margin-bottom: 8px;
  }

  .custom-input {
    background: #ffffff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 100px;
    border: none;
    outline: none;
    padding: 0 21px;
    height: 48px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: #474d52;
    &:focus {
      border: none;
      outline: none;
    }
    &::placeholder {
      font-weight: normal;
      font-size: 16px;
      color: #a1b1ba;
      margin-bottom: 8px;
      font-family: "Nunito", sans-serif;
    }
    &.active {
      border-radius: 20px 20px 0 0;
    }
  }
  h2 {
    font-weight: 600;
    font-size: 14px;
    display: flex;
    align-items: center;
    letter-spacing: 0.05em;
    color: #474d52;
    // margin-top: 27px;
    margin-bottom: 24px;
    @media (max-width: 650px) {
      &.specific {
        margin-top: 20px;
      }
    }
    span {
      padding-left: 4px;
      padding-bottom: 4px;
    }
    .optional {
      font-size: 12px;

      color: #8d99a0;
      padding-left: 8px;
    }
  }
  .specific {
    margin-top: 20px;
  }

  .location {
    opacity: 0;
  }
  .optional2 {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
    p {
      margin-left: 16px;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      display: flex;
      align-items: center;
      color: #474d52;
      margin: 0;
      margin-left: 16px;

      span {
        padding-left: 8px;
      }
    }
  }
  .input-group-text {
    border-right: none;
    background-color: #ffffff;
    border: none !important;
    cursor: pointer;
  }
  .btn-round-fill {
    width: 166px;
    height: 40px;
    margin-top: 24px;
    margin-bottom: 24px;
    margin-bottom: 80px;
  }
  .foot {
    border-top: 1px solid #ddd;
    margin-top: 32px;
  }
}
.toggler {
  position: relative;
  display: inline-block;
  width: 46.5px;
  height: 24px;
  background: #f3f6f9;
  border-radius: 18px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  cursor: pointer;
  @media (max-width: 590px) {
    margin-left: 15px;
  }
}
.slider {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: #b3c2cb;
  box-shadow: 0px 3px 9px #c4c4c4;

  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}
.bg {
  background: rgba(85, 126, 251, 0.1);
}
.btns {
  left: 50%;
  background: var(--theme-color);
  box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
}
#popover-target-1 {
  cursor: pointer;
}
.place-lived {
  height: 47px;
  background: #ffffff;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 100px;
  display: grid;
  grid-template-columns: 50px 1fr 50px;
  align-items: center;
  justify-content: center;
  .preprend {
    justify-content: center;
  }
  .input__place-lived {
    width: 100%;
    border: none;
    &:focus {
      box-shadow: none;
    }
  }
}
.places-lived {
  margin-top: 26px;
  .place__places-lived {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #474d52;
    margin: 6px 0;
  }
  .del__ico {
    cursor: pointer;
  }
}
.birthday_input {
  position: relative;
}
.birthday-calendar_wrapper {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1;
}
</style>
